export const flattenChartData = (data, labelArray) => {
  return data.reduce((original, item) => {
    // check first if data for that particular data has already been flattened
    if (
      original.findIndex(
        (flattenedItem) => flattenedItem.date === item.date
      ) === -1
    ) {
      // select all data within the same day
      const sameDayData = data.filter(
        (formattedItem) => item.date === formattedItem.date
      );
      // iterate same day data to flatten values within that day
      let formattedSameDayItem = null;
      sameDayData.forEach((sameDayItem) => {
        if (!formattedSameDayItem) {
          formattedSameDayItem = sameDayItem;
        } else {
          const addedSameDayItem = { ...formattedSameDayItem };

          labelArray.forEach((label) => {
            addedSameDayItem[label] += sameDayItem[label];
          });

          formattedSameDayItem = addedSameDayItem;
        }
      });

      original.push(formattedSameDayItem);
    }

    return original;
  }, []);
};
